import translate from '@allesauto/i18n';
import { formatPrice } from '@allesauto/utils/funcs';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import InfoIconBox from '../infoIconBox';

export interface CheckoutTradeInProps {
  modelName: string;
  tradeInPrice: number;
  customClassName?: string;
}

const CheckoutTradeIn: FC<CheckoutTradeInProps> = (
  props: CheckoutTradeInProps
) => {
  const { modelName, tradeInPrice, customClassName } = props;
  const intl = useIntl();

  const className = {
    listClasses: clsx(
      'columns-1 font-regular leading-5 px-15px py-15px text-p1 lg:px-40px lg:py-40px',
      customClassName
    ),
    titleClasses:
      'font-headline font-weight-bold leading-6 mb-20px text-headline4',
    contentClasses:
      'border-3px border-green60 flex justify-between p-15px lg:p-15px monochrome:border-black',
    priceClasses: 'mb-[6px] text-right lg:mb-[11px]',
    iconContainerClasses:
      'flex font-regular font-weight-normal text-grey100 text-p3',
  };

  return (
    <ul className={className.listClasses}>
      <li className={className.titleClasses}>
        {translate(intl, 'ui.CHECKOUT_SIDEBAR.TRADE_IN_TITLE')}
      </li>

      <li className="border-3px border-green60 flex justify-between p-15px wl-border-highlight lg:p-15px monochrome:border-black">
        <p className="table-cell">{modelName}</p>
        <div className="table-cell">
          <p className={className.priceClasses}>
            <span className='before:content-["-"]' />
            <span className='before:content-["_"]' />
            {formatPrice(intl, tradeInPrice, {
              withFractionDigits: true,
            })}
          </p>
          <div className={className.iconContainerClasses}>
            <span className="mr-5px">
              <InfoIconBox
                colorBlack={true}
                text={translate(
                  intl,
                  'ui.CHECKOUT_SIDEBAR.TRADE_IN_TOOLTIP_TEXT'
                )}
                customClassName={'!h-[14px] !w-[14px] mb-[1px]'}
              />
            </span>
            {translate(intl, 'ui.CHECKOUT_SIDEBAR.TRADE_IN_INFO_TEXT')}
          </div>
        </div>
      </li>
    </ul>
  );
};

export default CheckoutTradeIn;
